import { Helmet } from "react-helmet-async";

const SITE_URL = "https://yoursolicitor.co.uk";
const DEFAULT_TITLE = "YourSolicitor.co.uk | PCP & HP Car Finance Claims — No Win, No Fee";
const DEFAULT_DESC = "Were you mis-sold PCP or HP car finance? You could be owed £830 or more in hidden commission compensation. Expert solicitors, No Win No Fee. Takes less than 60 seconds to check.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  canonical,
  image = DEFAULT_IMAGE,
  noIndex = false,
}) {
  const url = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
